import type { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import { useCurrencyFormatter } from '@mint-lib/formatting-hooks';
import { useTranslation } from '@mint-lib/i18n';
import type { MediaPlan } from '@mint-sdk/api-media-plan';

import { EMPTY_CELL_VALUE } from '../../../consts/grid.consts.jsx';
import { NO_DECIMALS } from '../../../consts/index.js';
import type { CellRendererCommonType } from '../../../types/grid.types.js';
import { getFormattedValue } from '../../../utils/getFormattedValue.jsx';

const BudgetRenderer = (
  params: CustomCellRendererProps<MediaPlan.MediaData> & CellRendererCommonType,
) => {
  const { t } = useTranslation('@myn/planning_v2');

  const currencyFormatter = useCurrencyFormatter();

  const formattedValue = getFormattedValue(params, {
    formatterFn: () => {
      if (!params.data?.currencyCode) {
        return EMPTY_CELL_VALUE;
      }

      return currencyFormatter.format(params.value, {
        currency: params.data.currencyCode,
        minDecimals: params.decimalPlaces ?? NO_DECIMALS,
        maxDecimals: params.decimalPlaces ?? NO_DECIMALS,
      })?.formatted;
    },
    placeholderText: t('Insert'),
  });

  return <span className="flex justify-end">{formattedValue}</span>;
};

export default BudgetRenderer;
